import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as CUI from '@CUI';
import { useActions } from '@common/store-utils/hooks';
import { actions, selectors } from '@features/Login/model';
import { loginModel } from '@features/Login';
import isPasswordValid from '@/utility/validators/pass-validator';

import Button from '../components/shared/Button/Button';
import ButtonEnum from '../components/shared/Button/ButtonEnum';
import AuthCode from './OtpNew';

type OtpInputFieldProps = {
  digits?: number;
  onConfirm: () => void;
  onSendAgain?: () => void;
  onSetValue: (value: string) => void;
  isForgotPassword?: boolean;
};

export const OtpInputField: React.FC<OtpInputFieldProps> = ({
  digits = 6,
  onSetValue,
  onConfirm,
  onSendAgain,
  isForgotPassword,
}) => {
  const { t } = useTranslation();
  const [codeValue, setCodeValue] = useState('');

  const { setNewPassword, setPassword, setOtpCode } = useActions(actions);
  const password = selectors.usePassword();

  const onClickVerify = () => {
    if (isForgotPassword) {
      onConfirm();
      return;
    }
    if (codeValue.length === digits) {
      onSetValue(codeValue);
      onConfirm();
    }
  };

  useEffect(() => {
    if (codeValue.length === 6 && !isForgotPassword) {
      onSetValue(codeValue);
      onConfirm();
      setCodeValue('');
    }
  }, [codeValue]);

  if (isForgotPassword) {
    return (
      <>
        <div className="otp-wrapper">
          <div className={'reset-password-inputs-container'}>
            <div className={'id-input-container'}>
              <span className={'id-input-container-title'}>סיסמה זמנית</span>
              <CUI.Password
                form={loginModel.config.formName}
                showEvaluationMessage={false}
                autoComplete={'off'}
                maxLength={20}
                requiredMessage={t('FIELD_REQUIRED')}
                invalidMessage={t('ENTER_CORRECT_PASSWORD')}
                onChange={(e) => {
                  setOtpCode(e.component.value);
                }}
                name={'temporary-password'}
                isRequired
              />
            </div>
            <div className={'id-input-container'}>
              <span className={'id-input-container-title'}>סיסמה חדשה</span>
              <CUI.Password
                form={loginModel.config.formName}
                showEvaluationMessage={false}
                autoComplete={'off'}
                maxLength={20}
                validator={(value) => isPasswordValid(value)}
                requiredMessage={t('FIELD_REQUIRED')}
                invalidMessage={t('ENTER_CORRECT_PASSWORD')}
                onChange={(e) => {
                  setPassword(e.component.value);
                }}
                name={'password'}
                isRequired
              />
            </div>
            <div className={'id-input-container'}>
              <span className={'id-input-container-title'}>אימות סיסמה</span>
              <CUI.Password
                form={loginModel.config.formName}
                onPaste={(e: any) => {
                  e.preventDefault();
                  return false;
                }}
                requiredMessage={t('FIELD_REQUIRED')}
                invalidMessage={t('ENTER_SAME_PASSWORD')}
                autoComplete={'off'}
                maxLength={20}
                showEvaluationMessage={false}
                validator={(value) =>
                  value === password && isPasswordValid(value)
                }
                onChange={(e) => {
                  setNewPassword(e.component.value);
                }}
                name={'confirm-password'}
                isRequired
              />
            </div>
          </div>
          <div
            onClick={() => (onSendAgain ? onSendAgain() : null)}
            className="single-link pointer"
          >
            {t('SEND_TEMP_PASSWORD_AGAIN')}
          </div>
          <Button
            type={ButtonEnum.PRIMARY}
            onClick={onClickVerify}
            className="d-block w-100 sign-in-button"
            text={t('NEXT')}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="otp-wrapper">
        <label className="label-perach">{t('WHAT_CODE_YOU_RECEIVED')}</label>

        <AuthCode
          onChange={(value) => {
            setCodeValue(value);
          }}
          length={6}
          allowedCharacters={'numeric'}
          autoFocus={true}
          containerClassName={
            'code-verification d-flex align-items-center justify-content-between rr'
          }
          inputClassName={
            'aw otp-input-field text-center numeral-mask mx-25 mb-1'
          }
        />

        <div
          onClick={() => (onSendAgain ? onSendAgain() : null)}
          className="single-link pointer"
        >
          {t('SEND_CODE_AGAIN')}
        </div>
        <Button
          type={ButtonEnum.PRIMARY}
          onClick={onClickVerify}
          className="d-block w-100 sign-in-button"
          text={t('NEXT')}
        />
      </div>
    </>
  );
};
